import { mergeStates } from '@iwProvider/StoreHelper';

import {
    RESET_PROCESSING_PAYMENT_MODAL,
    SHOW_PROCESING_PAYMENT_MODAL,
    SHOW_PROCESING_PAYMENT_MODAL_AUTHENTICATION_REQUIRED,
    SHOW_PROCESING_PAYMENT_MODAL_COMPLETED,
    SHOW_PROCESING_PAYMENT_MODAL_ERROR,
    SHOW_PROCESING_PAYMENT_MODAL_INITIATED
} from './ProcessingPaymentModal.actions';

type TAction = {
    type?: string;
    paymentStatus?: string;
    amount?: number;
    paymentMethod?: string;
    mode?: string;
    authenticationIframeURL?: string;
    paymentInstructionId?: string;
    offerId?: string;
};

type TState = {
    paymentStatus: string | null;
    amount: number | null;
    paymentMethod: string | null;
    authenticationIframeURL: string | null;
    mode?: string;
    paymentInstructionId?: string | null;
    offerId: string | null;
};

const initialState = {
    paymentStatus: null,
    amount: null,
    paymentMethod: null,
    authenticationIframeURL: null,
    paymentInstructionId: null,
    offerId: null
};

// eslint-disable-next-line import/no-default-export
export default function (
    state: TState = mergeStates(initialState),
    action: TAction = {}
): TState {
    switch (action.type) {
        case SHOW_PROCESING_PAYMENT_MODAL:
            return mergeStates(state, {
                amount: action.amount,
                paymentMethod: action.paymentMethod,
                mode: action.mode,
                offerId: action.offerId
            });
        case SHOW_PROCESING_PAYMENT_MODAL_ERROR:
            return mergeStates(state, {
                paymentStatus: 'failure'
            });
        case SHOW_PROCESING_PAYMENT_MODAL_INITIATED:
            return mergeStates(state, {
                paymentStatus: 'initiated',
                paymentInstructionId: action.paymentInstructionId
            });
        case SHOW_PROCESING_PAYMENT_MODAL_COMPLETED:
            return mergeStates(state, {
                paymentStatus: 'success'
            });
        case SHOW_PROCESING_PAYMENT_MODAL_AUTHENTICATION_REQUIRED:
            return mergeStates(state, {
                paymentStatus: 'authentication_required',
                authenticationIframeURL: action.authenticationIframeURL
            });
        case RESET_PROCESSING_PAYMENT_MODAL:
            return mergeStates(initialState);
        default:
            return state;
    }
}
